export const Cancel = 3;
export const Help = 6;
export const Backspace = 8;
export const Tab = 9;
export const Clear = 12;
export const Enter = 13;
export const Shift = 16;
export const Control = 17;
export const Alt = 18;
export const Pause = 19;
export const CapsLock = 20;
export const Escape = 27;
export const Convert = 28;
export const NonConvert = 29;
export const Accept = 30;
export const ModeChange = 31;
export const Space = 32;
export const PageUp = 33;
export const PageDown = 34;
export const End = 35;
export const Home = 36;
export const ArrowLeft = 37;
export const ArrowUp = 38;
export const ArrowRight = 39;
export const ArrowDown = 40;
export const Select = 41;
export const Print = 42;
export const Execute = 43;
export const PrintScreen = 44;
export const Insert = 45;
export const Delete = 46;
export const Digit0 = 48;
export const RightParenthesis = 48;
export const Digit1 = 49;
export const ExclamationPoint = 49;
export const Digit2 = 50;
export const AtSign = 50;
export const Digit3 = 51;
export const PoundSign = 51;
export const Digit4 = 52;
export const DollarSign = 52;
export const Digit5 = 53;
export const PercentSign = 53;
export const Digit6 = 54;
export const Caret = 54;
export const Digit7 = 55;
export const Ampersand = 55;
export const Digit8 = 56;
export const MultiplicationSign = 56;
export const Digit9 = 57;
export const LeftParenthesis = 57;
export const a = 65;
export const A = 65;
export const b = 66;
export const B = 66;
export const c = 67;
export const C = 67;
export const d = 68;
export const D = 68;
export const e = 69;
export const E = 69;
export const f = 70;
export const F = 70;
export const g = 71;
export const G = 71;
export const h = 72;
export const H = 72;
export const i = 73;
export const I = 73;
export const j = 74;
export const J = 74;
export const k = 75;
export const K = 75;
export const l = 76;
export const L = 76;
export const m = 77;
export const M = 77;
export const n = 78;
export const N = 78;
export const o = 79;
export const O = 79;
export const p = 80;
export const P = 80;
export const q = 81;
export const Q = 81;
export const r = 82;
export const R = 82;
export const s = 83;
export const S = 83;
export const t = 84;
export const T = 84;
export const u = 85;
export const U = 85;
export const v = 86;
export const V = 86;
export const w = 87;
export const W = 87;
export const x = 88;
export const X = 88;
export const y = 89;
export const Y = 89;
export const z = 90;
export const Z = 90;
export const OS = 91;
export const ContextMenu = 93;
export const F1 = 112;
export const F2 = 113;
export const F3 = 114;
export const F4 = 115;
export const F5 = 116;
export const F6 = 117;
export const F7 = 118;
export const F8 = 119;
export const F9 = 120;
export const F10 = 121;
export const F11 = 122;
export const F12 = 123;
export const F13 = 124;
export const F14 = 125;
export const F15 = 126;
export const F16 = 127;
export const F17 = 128;
export const F18 = 129;
export const F19 = 130;
export const F20 = 131;
export const F21 = 132;
export const F22 = 133;
export const F23 = 134;
export const F24 = 135;
export const NumLock = 144;
export const ScrollLock = 145;
export const VolumeMute = 181;
export const VolumeDown = 182;
export const VolumeUp = 183;
export const Semicolon = 186;
export const EqualsSign = 187;
export const PlusSign = 187;
export const Comma = 188;
export const LeftAngleBracket = 188;
export const MinusSign = 189;
export const Underscore = 189;
export const Decimal = 190;
export const RightAngleBracket = 190;
export const ForwardSlash = 191;
export const QuestionMark = 191;
export const GraveAccent = 192;
export const Tilde = 192;
export const LeftSquareBracket = 219;
export const LeftCurlyBrace = 219;
export const BackSlash = 220;
export const Pipe = 220;
export const RightSquareBracket = 221;
export const RightCurlyBrace = 221;
export const SingleQuote = 222;
export const DoubleQuote = 222;
export const Meta = 224;
export const AltGraph = 225;
export const Attn = 246;
export const CrSel = 247;
export const ExSel = 248;
export const EraseEof = 249;
export const Play = 250;
export const ZoomOut = 251;
